import React, { useEffect, useState } from 'react'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import MailTwoToneIcon from '@mui/icons-material/MailTwoTone';
import LocationOnTwoToneIcon from '@mui/icons-material/LocationOnTwoTone';
import CallTwoToneIcon from '@mui/icons-material/CallTwoTone';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import AccountCircleTwoToneIcon from '@mui/icons-material/AccountCircleTwoTone';
import AccountBoxTwoToneIcon from '@mui/icons-material/AccountBoxTwoTone';
import LogoutTwoToneIcon from '@mui/icons-material/LogoutTwoTone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import './Header.css';
import Swal from 'sweetalert2';
import { getLogout, getUserApi } from './ApiService';


const Header = ({ onScrollToGallery, onScrollToContact }) => {
    const navigate = useNavigate()
    const [showMenu, setShowMenu] = useState(false)
    const [userDtl, setuserDtl] = useState(null)
    const [showProfile, setshowProfile] = useState(false)
    const [token, setToken] = useState('')
    const [userDetails, setUserDetails] = useState('')
    const [contact, setcontact] = useState('')
    const [email, setEmail] = useState('')
    const [lastName, setlastName] = useState('')
    const [firstName, setfirstName] = useState('')

    const handleMobileClick = () => {
        setShowMenu(!showMenu)
    }

    useEffect(() => {
        const dtl = localStorage.getItem("user")
        if (dtl) {
            const parsedUser = JSON.parse(dtl)
            setuserDtl(parsedUser)
            // console.log(parsedUser, "parsedUser")
        }

        // GET USER DETAILS
        const loginDtl = localStorage.getItem("user")
        if (loginDtl) {
            const parsedUser = JSON.parse(dtl)
            // setuserDtl(parsedUser)
            // console.log(parsedUser.token, "UPDATE-PROFILE TOKEN")
            setToken(parsedUser.token)

            getUserApi(parsedUser.token).then((res) => {
                setUserDetails(res.data)
                setfirstName(res.data?.user?.firstName)
                setlastName(res.data?.user?.lastName)
                setEmail(res.data?.user?.emailAddress)
                setcontact(res.data?.user?.phoneNumber)
                // console.log(res.data, "RESPONSE USER DETAILS")
            }).catch((error) => {
                const Toast = Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.onmouseenter = Swal.stopTimer;
                        toast.onmouseleave = Swal.resumeTimer;
                    }
                });
                Toast.fire({
                    icon: "error",
                    title: error.response.data.message
                });
            })
        }
    }, [])

    const openProfile = () => {
        setshowProfile(!showProfile)
    }

    const logout = () => {
        var token = userDtl.token

        getLogout(token).then((res) => {
            console.log(res, "LOGOUT")
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "success",
                title: res?.data.message
            });
            localStorage.clear()
            setuserDtl(null)
            setshowProfile(!showProfile)
            navigate('/')
        }).catch((error) => {
            console.log(error, "LOGOUT ERR")
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: error?.response.data.message
            });
        })
    }

    // Helper to close menu on navigation
    const handleNavClick = () => setShowMenu(false);

    return (
        <>
            <section className='topBarCont'>
                <div className='container'>
                    <div className='topBar'>
                        <ul className='topBarLeft'>
                            <li>
                                <span> <MailTwoToneIcon /> </span>
                                <a href='mailto:care@cargenie.co.in'> care@cargenie.co.in </a>
                            </li>

                            <li>
                                <span> <LocationOnTwoToneIcon /> </span>
                                <a href='https://www.google.com/maps?daddr=Car+Genie,+Bridge,+near+Dunlop,+Dunlop,+Saket+Nagar,+Bonhooghly+Government+Colony,+Ashokgarh,+Baranagar,+West+Bengal,+India' target='_blank' rel="noreferrer"> Car Genie, Kolkata </a>
                            </li>

                            <li>
                                <span>
                                    <CallTwoToneIcon />
                                </span>
                                <a href='tel:7003900368'> +91-7003900368 </a>
                            </li>
                        </ul>

                        <ul className='topBarRight'>
                            {/* <p style={{ marginRight: '20px' }}>Connect Us : </p> */}
                            <li style={{ marginRight: '10px' }}>
                                <a href='https://www.facebook.com/172441045957753'>
                                    <img src="images/facebook.png" className='img-fluid' style={{ width: '22px' }} alt='CarGenie' />
                                </a>
                            </li>
                            <li>
                                <a href='https://www.instagram.com/cargenieindia?igsh=bmc2cjM3dXp1czF1'>
                                    <img src="images/instagram.png" className='img-fluid' style={{ width: '22px' }} alt='CarGenie' />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            <section className='navBar'>
                <div className='container'>
                    <div className='row'>
                        <div className='header'>
                            <Link to="/" className='logo'>
                                <img src="images/logo.png" className='img-fluid' alt='car-genie' />
                            </Link>

                            <div className={showMenu ? 'mobileCont' : 'desktopCont'}>
                                <ul className='headerCont'>
                                    <li>
                                        <NavLink
                                            to="/about"
                                            className={({ isActive, isPending }) =>
                                                isPending ? "pending" : isActive ? "active" : ""
                                            }
                                            onClick={handleNavClick}
                                        >
                                            About Us
                                        </NavLink>
                                    </li>                                    

                                    <li>
                                        <NavLink
                                            to="/services"
                                            className={({ isActive, isPending }) =>
                                                isPending ? "pending" : isActive ? "active" : ""
                                            }
                                            onClick={handleNavClick}
                                        >
                                            Services
                                        </NavLink>
                                    </li>

                                    <li>
                                        <NavLink
                                            to="/Team"
                                            className={({ isActive, isPending }) =>
                                                isPending ? "pending" : isActive ? "active" : ""
                                            }
                                            onClick={handleNavClick}
                                        >
                                            Team
                                        </NavLink>
                                    </li>

                                    <li onClick={(e) => { onScrollToGallery && onScrollToGallery(e); handleNavClick(); }}>
                                        <NavLink
                                            // to="/gallery"                                            
                                            className={({ isActive, isPending }) =>
                                                isPending ? "pending" : isActive ? "active" : ""
                                            }
                                        >
                                            Gallery
                                        </NavLink>
                                    </li>

                                    <li onClick={(e) => { onScrollToContact && onScrollToContact(e); handleNavClick(); }}>
                                        <NavLink
                                            // to="/contact"
                                            className={({ isActive, isPending }) =>
                                                isPending ? "pending" : isActive ? "active" : ""
                                            }
                                        >
                                            Contact Us
                                        </NavLink>
                                    </li>


                                </ul>

                                {userDtl ?
                                    <>
                                        <AccountCircleTwoToneIcon
                                            fontSize="large"
                                            color="primary"
                                            style={{ marginRight: '15px', cursor: 'pointer' }}
                                            onClick={openProfile}
                                            className='showProfileIcon'
                                        />
                                    </>
                                    :
                                    <>
                                        {/* <Link to="/login">
                                            <Button variant="outlined" color="secondary" size="medium" className='roundedBox' style={{ marginRight: '20px' }} navigate> Login </Button>
                                        </Link> */}

                                        <Button
                                            href="https://api.whatsapp.com/send?phone=7003900368"
                                            variant="contained"
                                            color="secondary"
                                            size="medium"
                                            className='roundedBox'
                                            startIcon={<WhatsAppIcon />}
                                            // style={{ marginRight: '20px' }} 
                                            navigate>
                                            Connect Genie
                                        </Button>

                                    </>}
                                {showProfile ?
                                    <>
                                        <ul className='profileCont'>
                                            <p>Hi, {userDtl?.userDetails.firstName}</p>
                                            <li>
                                                <AccountBoxTwoToneIcon color="primary" />
                                                <Link to="/profile" style={{ color: "#000", marginLeft: '10px' }}>My Account</Link>
                                            </li>
                                            <li>
                                                <LogoutTwoToneIcon color="primary" />
                                                <Link onClick={logout} style={{ color: "#000", marginLeft: '10px' }}>Logout</Link>
                                            </li>
                                        </ul>
                                    </>
                                    : ""}
                                {/* <Button
                                    variant="contained"
                                    color="secondary"
                                    size="medium"
                                    className='roundedBox'
                                    endIcon={<SendIcon />}
                                    onClick={() => navigate('/services')}
                                >GET A QUOTE</Button> */}

                                {/* <Button
                                    href="https://api.whatsapp.com/send?phone=7003900368"
                                    variant="contained"
                                    color="secondary"
                                    size="medium"
                                    className='roundedBox'
                                    startIcon={<WhatsAppIcon />}
                                    // style={{ marginRight: '20px' }} 
                                    navigate>
                                    Connect Genie
                                </Button> */}
                            </div>

                            <Button className='hamMenu'>
                                <MenuTwoToneIcon onClick={handleMobileClick} />
                            </Button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Header